<template>
  <div>
    <page-main
      :tableData="tableData"
      :shipmentBookingCode="shipmentBookingCode"
      :shipmentCode="shipmentCode"
      :isNStatus="isNStatus"
      :loading="loading"
      :disabled="disabled"
      :height="height"
      @reload="loadData"
      ref="main"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        :isNStatus="isNStatus"
        @batchDel="$refs.main.removeCheckboxRow()"
        @openAddDialog="openAddDialog"
      />
    </page-main>
    <ChooseShipmentContainer
      :visible.sync="visible"
      :title="'装柜记录信息'"
      :shipmentCode="shipmentCode"
      :data="tableData"
      type="checkbox"
      @confirm="confirm"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import ChooseShipmentContainer from '../choose-shipment-container/dialog.vue'

export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageHeader,
    PageMain,
    ChooseShipmentContainer,
  },
  props: {
    shipmentCode: { type: String, default: '' },
    isNStatus: { type: Boolean, default: false },
    shipmentBookingCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    height: { type: Number, default: 0 },
  },
  mounted() {
    this.loadData()
  },
  data() {
    return {
      tableData: [],
      visible: false,
    }
  },
  methods: {
    loadData() {
      if (!this.shipmentBookingCode) return
      this.loading = true
      this.$api
        .shipmentBookingContainerListApi({
          shipmentCode: this.shipmentCode,
          shipmentBookingCode: this.shipmentBookingCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
    validate() {
      return this.$refs.main.validate()
    },
    openAddDialog() {
      this.visible = true
    },
    confirm(params) {
      var info = params
        .map((t) => t.shipmentContainerCode)
        .filter(
          (i) =>
            this.tableData.findIndex((j) => j.shipmentContainerCode === i) < 0
        )
      if (info.length === 0) {
        this.$message({
          showClose: true,
          message: '数据已存在',
          type: 'error',
        })
        return
      }
      this.loading = true
      this.$api
        .shipmentBookingContainerSaveApi({
          shipmentCode: this.shipmentCode,
          shipmentBookingCode: this.shipmentBookingCode,
          listContainer: params,
        })
        .then(() => {
          this.loading = false
          this.loadData()
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
